import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import {QoteImage} from '../../assets/index'
import { Navigation, Pagination, Autoplay } from "swiper/modules"; // Added Autoplay
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import '../../styles/AluminiSpeakWebsite.css'
import { getAlumniSpeaks } from '../../services/getAllApi'


const AluminiSpeakWebSite = () => {
  const [testimonials, setTestimonials] = useState([])
  useEffect(() => {
    getAlumniSpeaks()
      .then((response) => setTestimonials(response.data))
  }, [])
  return (
    <>
      <div className="alumni-section">
        <div className="alumniline"></div>
        <h2 className="alumni-heading">Alumni Speak</h2>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]} // Added Autoplay
          spaceBetween={30}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // Keeps autoplay running after user interaction
          }}
          breakpoints={{
            320: { slidesPerView: 1 }, // Mobile
            768: { slidesPerView: 2 }, // Tablet
            1024: { slidesPerView: 3 }, // Desktop
          }}
          className="alumni-swiper"
        >
          {testimonials && testimonials.length > 0 ?
            testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <div className="alumni-card">
                  <div className="alumni_imgbx">
                    {/* <img src={testimonial.student_photo} alt={`${testimonial.student_name}'s photo`} className="alumni-photo" /> */}
                    <img src={`${"https://console.fbsedu.in/storage/app/"}/${testimonial.student_photo}`}/>
                  </div>

                  <p className="testimonial-text">
                    <div className="a_quote">
                      <img src={QoteImage} alt="Quotes Icon" className="qicon" />
                    </div>
                    {testimonial.company_name}
                  </p>
                  <h3 className="alumni-name">{testimonial.student_name}</h3>
                  <p className="alumni-position">{testimonial.description}</p>
                  <div className="company">
                    <img src={`${"https://console.fbsedu.in/storage/app/"}/${testimonial.company_logo}`} alt={`${testimonial.company_name}'s logo`} className="company-logo" />


                  </div>
                  <div className="tooltip-triangle"></div>
                </div>
              </SwiperSlide>
            ))
            :
            "No Data found for Alumini Speaks"

          }
        </Swiper>
      </div>
    </>
  )
}

export default AluminiSpeakWebSite